<template>
  <span>
    <h1 v-if="!editing" class="view-title__header">
      <!-- @slot The view's title. This title will be read by screen readers so it should not contains links and buttons. -->
      <slot>{{ value }}</slot>
    </h1>
    <form-button
      v-if="editable && !editing"
      tertiary
      class="view-title__action"
      @click="toggleEdit"
    >
      <icon icon="pencil" />
      <span class="sr-only">Edit {{ ariaLabel }}</span>
    </form-button>
    <async-form
      v-if="editing"
      class="view-title__form"
      @submit="saveValue"
      persist
    >
      <text-input
        v-model="mutableValue"
        :aria-label="ariaLabel"
        rules="required"
        class="view-title__input"
      />
      <form-button
        v-if="editable"
        tertiary
        class="view-title__action"
        type="submit"
      >
        <icon icon="check" />
        <span class="sr-only">Save</span>
      </form-button>
      <form-button
        v-if="editable"
        tertiary
        class="view-title__action"
        @click="toggleEdit"
      >
        <icon icon="times" />
        <span class="sr-only">Cancel</span>
      </form-button>
    </async-form>
  </span>
</template>

<script>
export default {
  name: 'ViewTitle',
  emits: ['submit'],
  props: {
    /**
     * Allows the title to be modified.
     */
    editable: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * The editable title value.
     * Raises the `submit` event when changed.
     * Required when `editable` is `true`.
     */
    value: {
      type: String,
      required: false
    },
    /**
     * Provides the accessible label to the editable title.
     * Required when `editable` is `true`.
     */
    ariaLabel: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      editing: false,
      mutableValue: ''
    }
  },
  methods: {
    toggleEdit() {
      if (this.value) this.mutableValue = this.value
      this.editing = !this.editing
    },
    saveValue() {
      /**
       * Raised with the new title when it is changed.
       * @type {String}
       */
      this.$emit('submit', this.mutableValue)
      this.editing = false
    }
  }
}
</script>

<style lang="scss" scoped>
.view-title__header {
  margin: 0;
  padding: 2px 0 0 0;
  display: inline-block;
}

.view-title__form {
  margin: 0;
}

.view-title__input {
  display: inline-block;
  width: 300px;
}
.view-title__action {
  font-size: 16px;
  line-height: 27.5px;
  display: inline-block;
  width: 41px;
  height: 41px;
  padding: 0;
}
</style>
